// export const EMAIL_REGEXP = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i
export const PASSWORD_REQUIREMENT_REGEXP = /^(?=.*?[A-ZА-ЯЁ])(?=.*?(?=[0-9]|[#?!@$%^&*-][0-9])).{8,}$/
export const PASSWORD_EMPTY_REGEXP = /^.{1,}$/
export const ONE_NUMERIC_DIGIT_REGEXP = /^\d$/
export const PASSWORD_CARD_REQUIREMENT_REGEXP = /^[A-Za-z0-9!#;:\?"\*\(\)\+=&\[\],\.\{\}\\\/]*$/
